export class Util {

    static getTypedResponse<T>(response: any, prototype: object): T {
        const typedResponse = Object.create(prototype);
        return Object.assign(typedResponse, response) as T;
    }
}
